
<template>
  <div>
    <el-form size="small" ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item align="left" label="Version" required>
        <!-- <el-col :span="8">
  <el-form-item prop="version"><el-input v-model.number="form.version" @change="checkOldVersion"></el-input></el-form-item>
</el-col>	 -->
        <el-col :span="3">
          <el-form-item prop="pos1">
            <el-input oninput="if(value.length>2)value=value.slice(0,2)" v-model.number="form.pos1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1">
          <p>.</p>
        </el-col>
        <el-col :span="3">
          <el-form-item prop="pos2">
            <el-input oninput="if(value.length>2)value=value.slice(0,2)" v-model.number="form.pos2"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1">
          <p>.</p>
        </el-col>
        <el-col :span="3">
          <el-form-item prop="pos3">
            <el-input oninput="if(value.length>2)value=value.slice(0,2)" v-model="form.pos3"></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item prop="file" align="left" label="file">
        <label style="margin-left:20px;width: 100px;"
               class="float-left btn-block re-upload-img-btn">
          upload file
          <input ref="file" accept="" type="file" @change="fileChange" class="re-upload-img"/>
        </label>
      </el-form-item>
      <el-form-item  align="left">
        <label v-if="filename!=''" style="width: 90%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" v-html="'file:'+filename"></label>
      </el-form-item>
      <el-form-item align="left" label="Last Version" prop="lastVersion">
        <el-input v-model="form.last_version"></el-input>
      </el-form-item>
      <el-form-item align="left" label="strategy">
        <el-select v-model="form.strategy" placeholder="strategy">
          <el-option label="direct" value="1"></el-option>
          <el-option label="prompt" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item align="left" label="support type">
        <el-select v-model="form.support_type" default-first-option>
          <el-option value="full"></el-option>
          <el-option value="delta"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item align="left" label="md5">
        <el-input v-model="form.md5" placeholder="md5"></el-input>
      </el-form-item>
      <el-form-item align="left" label="uuids">
        <el-input v-model="form.uuids" placeholder=""></el-input>
      </el-form-item>
      <el-form-item align="left" label="description">
        <el-input type="textarea" v-model="form.description" ></el-input>
      </el-form-item>
      <el-form-item align="right">
        <el-button @click="goBack" plain>Back</el-button>
        <el-button class="el-button--primary" @click="submit('form')">Save</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<style scoped>
  .textarea-wrap >>> textarea {
    height: 200px;
  }

  .old-version-list .el-checkbox {
    display: block;
    margin-left: 0;
  }
</style>

<script>
  export default {
    name: 'DeviceAudioVersionAdd',
    props: {
      closeDialog: Function,
      dialogSucc: Function
    },
    data () {
      return {
        old_versions: [],
        filename:'',
        pre:'',
        form: {
          pos1: '',
          pos2: '',
          pos3: '',
          version: '',
          last_version: 'ALL',
          description: '',
          strategy: '1',
          md5:'',
          uuids:'',
          // old_versions: [],
          // del_old_versions: [],
          file: null,
          url:'',
          support_type:'full'
        },
        rules: {
          pos1: [
            {required: true, message: 'please input', trigger: 'blur'},
            {pattern:/^\d*$/,message: 'please input number', trigger: 'blur'}
          ],
          pos2: [
            {required: true, message: 'please input', trigger: 'blur'},
            {pattern:/^\d*$/,message: 'please input number', trigger: 'blur'}
          ],
          pos3: [
            {required: true, message: 'please input', trigger: 'blur'},
            {pattern:/^\d*$/,message: 'please input number', trigger: 'blur'},
          ],
          pos4: [
            {required: true, message: 'please input', trigger: 'blur'},
            {type: 'number', message: 'please input number', trigger: 'blur'},
          ],
          strategy: [{required: true, message: 'Please select an upgrade strategy!', trigger: 'change'}],
          is_quiet: [{required: true, message: 'Please choose whether to be silent!', trigger: 'change'}]
        }
      }
    },
    created () {
    },
    mounted () {

    },
    methods: {
      goBack () {
        this.$emit('closeDialog')
      },
      fileChange () {
        console.log('devAudioFileChange')
        this.form.file = this.$refs.file.files[0]
        this.filename=this.$refs.file.files[0].name
        this.$refs.file.value=''
        this.uploadFile()
      },
      uploadFile () {
        if (!this.form.file) {
          return this.$message.warning('Please select a file!')
        }
        console.log('this.form.devAudioFile:', this.form.file)
        var formData = new FormData()
        formData.append('file', this.form.file)
        formData.append('type', 'devAudio')

        // 黑幕
        const loading = this.$util.loading('loading...')
        this.$api.rootV1.post('/common/uploadDefault', formData, (res) => {
          loading.close()
          console.log('upload res:', res)
          if (res.errcode === 0) {
            this.$message.success('upload success')
            this.form.url = res.data.url
            this.$refs['form'].fields[1].validateMessage = ''
            this.$refs['form'].fields[1].validateState = 'success'
          } else {
            this.$message.error('upload fail')
          }
        })
      },
      async submit (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.form.version = this.form.pos1 + '.' + this.form.pos2 + '.' + this.form.pos3
            if (!this.form.last_version) {
              return this.$message.error('Need a last version')
            }

            let params = new FormData()
            params.append('version',this.form.version)
            params.append('url',this.form.url)
            params.append('description',this.form.description)
            params.append('strategy',this.form.strategy)
            params.append('last_version',this.form.last_version)
            params.append('uuids',this.form.uuids)
            params.append('md5',this.form.md5)
            params.append('support_type',this.form.support_type)
            //return console.log(JSON.stringify(this.form))
            // 黑幕
            const loading = this.$loading({
              lock: true,
              text: 'loading......',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            this.$api.rootV1.post('/web/deviceaudioversion/add', params, (res) => {

              if (res.errcode === 0) {
                this.$alert('add successfully!', 'info', {
                  confirmButtonText: 'confirm',
                  type: 'success',
                  callback: action => {
                    loading.close()
                    this.$emit('dialogSucc')
                  }
                })
              } else {
                this.$alert(`add failed!${res.errmsg}`, 'info', {
                  confirmButtonText: 'confirm',
                  type: 'error',
                  callback: action => {
                    loading.close()
                  }
                })
              }
            },(res) => {
              loading.close()
              this.$message.warning(res.errmsg)
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },

    },
    watch: {}
  }
</script>




// WEBPACK FOOTER //
// src/components/main/deviceAudio/DeviceAudioVersionAdd.vue